// Google Analytics 4 wrapper. Loads gtag.js only when a measurement ID is
// configured (REACT_APP_GA_MEASUREMENT_ID) AND the build is production, so
// dev sessions and unconfigured deploys send nothing.
//
// Privacy rules — this app holds student PII, none of it goes to Google:
//   - no emails, names, or tokens in any event or property
//   - page paths are normalized (UUIDs/slugs → :id) before sending, so URLs
//     can't act as quasi-identifiers and GA aggregates per screen, not per
//     record ("Course Player: 500 views" instead of 500 one-view pages)
//   - the only user property is a coarse role (admin | participant) for
//     audience segmentation

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let initialized = false;

function gtag() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(arguments);
}

export function initAnalytics() {
  if (initialized || !GA_ID || process.env.NODE_ENV !== "production") return;
  initialized = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  gtag("js", new Date());
  // send_page_view off: the SPA router fires page_view explicitly on every
  // route change (the initial load included), so we don't double-count.
  gtag("config", GA_ID, { send_page_view: false });
}

const UUID_RE = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;

// Collapse identifying/high-cardinality segments so GA groups by screen.
export function normalizePath(pathname) {
  let p = pathname.replace(UUID_RE, ":id");
  p = p.replace(/^\/quiz\/[^/]+/, "/quiz/:slug");
  p = p.replace(/^\/s\/[^/]+/, "/s/:slug");
  p = p.replace(/^\/[^/]+\/login$/, "/:orgSlug/login");
  return p;
}

export function trackPageView(pathname) {
  if (!initialized) return;
  const page_path = normalizePath(pathname);
  gtag("event", "page_view", {
    page_path,
    page_title: page_path,
    // Deliberately NOT window.location.href — real URLs carry ids/slugs.
    page_location: window.location.origin + page_path,
  });
}

export function trackEvent(name, params = {}) {
  if (!initialized) return;
  gtag("event", name, params);
}

// role: "admin" | "superadmin" | "participant"
export function setAnalyticsRole(role) {
  if (!initialized || !role) return;
  gtag("set", "user_properties", { app_role: role });
}
